import { Paper, Box, useTheme } from '@mui/material';
import Dialog, { IDialogRef } from 'components/Dialog';
import Navbar from 'components/Navbar';
import ConfirmContent from 'components/ResponseUIs/ConfirmContent';
import Sidebar from 'components/Sidebar';
import { useAuthContext } from 'context/AuthContext';
import useAlert, { AppAlert } from 'hook/useAlert';
import { ShieldSecurity } from 'iconsax-react';
import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import eventBus from 'utils/eventBus';

export default function Home() {
  // context
  const { logout } = useAuthContext();
  // hooks
  const dialogRef = useRef<IDialogRef>(null);
  const alert = useAlert();
  const theme = useTheme();

  useEffect(() => {
    const alertSuccess = ({ message }: { message: string }) => {
      alert.setAlertState({
        isAlert: true,
        message: message,
        type: 'success',
      });
    };
    const alertError = ({ message }: { message: string }) => {
      alert.setAlertState({
        isAlert: true,
        message: message,
        type: 'error',
      });
    };
    const authLogin = ({ message }: { message: string }) => {
      dialogRef.current?.open(message);
    };
    eventBus.on('alert:success', alertSuccess);
    eventBus.on('alert:error', alertError);
    eventBus.on('auth:login', authLogin);
    return () => {
      eventBus.off('alert:success', alertSuccess); // Cleanup
      eventBus.off('alert:error', alertError); // Cleanup
      eventBus.off('auth:login', authLogin); // Cleanup
    };
  });
  return (
    <>
      <AppAlert alert={alert.alertState} onClose={alert.onCloseAlert} />
      <Dialog
        ref={dialogRef}
        dialogContentProps={{
          sx: {
            p: 2,
          },
        }}
        content={(params) => (
          <ConfirmContent
            onClose={() => dialogRef.current?.close()}
            onConfirm={() => logout()}
            title='Unauthorized'
            message={params}
            boxWidth={'100%'}
            icon={
              <ShieldSecurity size='32' color={theme.palette.primary.main} />
            }
          />
        )}
      />
      <Box component={Paper} display='flex'>
        <Sidebar />
        <Paper
          component='main'
          sx={{
            flexGrow: 1,
            bgcolor: 'background.paper',
            height: '100svh',
            overflow: 'auto',
            borderRadius: 0,
            overscrollBehavior: 'none',
          }}
        >
          <Navbar />
          <Outlet />
        </Paper>
      </Box>
    </>
  );
}
